/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React from 'react';
import {ThemeShape} from '@dvrd/dvr-controls';

import User from "../models/userModel";

export interface UserContext {
    user: User | null,
    onChange: Function,
}

export interface ContextShape {
    userContext: UserContext,
    theme: ThemeShape,
    onChangeContext: (config: UpdateContextConfig, callback?: VoidFunction) => void;
}



//===========================
// TYPES
//===========================
export type FieldDefinition = {
    expectedType: string; convertToBoolean: boolean; allowNull?: boolean; allowUndefined?: boolean; defaultValue?: any
};
export type Navigation = {
    route: string, isUrl?: boolean, scrollId?: string, label: string, subNavigation?: Navigation[],
    component: React.ReactElement, mobileLabel?: string, authenticated: boolean;
};
export type UpdateContextConfig = { user?: User | null; };

//===========================
// ENUMS
//===========================
export enum UserType {
    ADMIN = 'admin', USER = 'user',
}

export enum DataMode {
    DETAILS, EDIT
}

export enum EditMode {
    NEW, EDIT
}

export enum UserStatus {ACTIVE = 'active', INVITED = 'invited', DELETED = 'deleted', REGISTERED = 'registered'}